import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "./TabLayout.scss";
import MembersVideoGrid from "../MembersVideoGrid/MembersVideoGrid";
import Summary from "../Summary/Summary";
import {
  CheckValue,
  getAvailableUser,
} from "../../../../services/CommonFunction";
import Chat from "../../../../components/UI/Chat/Chat";

export default function TabLayout({ tabs, onSelected }) {
  const [selected, setSelected] = useState(0);
  if (!tabs || tabs.length === 0) return;
  const headers = tabs.map((tab, index) => {
    return (
      <div
        className={`TabTitle${index === selected ? " selected" : ""}`}
        key={index}
        onClick={() => {
          setSelected(index);
          onSelected(index);
          console.log(index);
        }}
      >
        {tab.title}
      </div>
    );
  });
  const bodies = tabs.map((tab, index) => {
    return (
      <div className={`${index !== selected ? "hidden" : ""}`} key={index}>
        {tab.content}
      </div>
    );
  });

  return (
    <React.Fragment>
      <div className={"TabsContainer"}>
        <div className={"Header box-layer3"}>{headers}</div>
        <div className={"Body"}>{bodies}</div>
      </div>
    </React.Fragment>
  );
}
export const TabLayoutUI = (props) => {
  const newMsgCount = localStorage.getItem("messageCount");
  const { allUsers, isHangoutRoom } = props;
  const [tabData, setTabData] = useState(() => {
    return [
      {
        title: "Participants:",
        type: "participants",
        show: true,
      },
      {
        title: "Chat",
        type: "chat",
        show: true,
      },
      {
        title: "Summary",
        type: "summary",
        show: false,
      },
    ];
  });

  useEffect(() => {
    setTabData((prevState) =>
      [...prevState].map((el) =>
        el.type === "summary" ? { ...el, show: isHangoutRoom } : { ...el }
      )
    );
  }, [isHangoutRoom]);

  const [selected, setSelected] = useState("participants");

  const headers = tabData
    .filter((el) => el.show)
    .map((tab, index) => {
      const { allUserLength } = getAvailableUser(allUsers, "not_ended");
      let text = "";
      if (CheckValue(newMsgCount) && typeof newMsgCount === "number") {
        const _newMsgCount = Number(newMsgCount);
        if (_newMsgCount > 0) {
          text += " (";
          if (_newMsgCount < 9) {
            text += _newMsgCount;
          } else {
            text += "9+";
          }
          text += ")";
        }
      }
      return (
        <div
          className={`TabTitle${tab.type === selected ? " selected" : ""}`}
          key={index}
          onClick={() => {
            setSelected(tab.type);
          }}
        >
          {`${tab.title} `}
          {tab.type === "participants" && allUserLength ? allUserLength : null}
          {tab.type === "chat" ? text : null}
        </div>
      );
    });

  return (
    <React.Fragment>
      <div className={"TabsContainer"}>
        <div className={"Header box-layer3"}>{headers}</div>
        <TabBody selected={selected} tabs={tabData} {...props} />
      </div>
    </React.Fragment>
  );
};

const TabBody = (props) => {
  const chatRef = useRef(null);
  const paginationRef = useRef(null);
  const {
    tabs,
    selected,
    socket,
    staffsInActivity,
    coachData,
    gymData,
    allUsers,
    userActivityData,
  } = props;
  // console.log("ChatUI", props);
  const chatUI = useMemo(
    () => (
      <ChatUI {...props} chatSelected={"chat" === selected} chatRef={chatRef} />
    ),
    [
      selected,
      socket.connected,
      gymData,
      Object.keys(staffsInActivity).length,
      Object.keys(allUsers).length,
      coachData,
      userActivityData,
    ]
  );
  const memberVideoGridUI = <MemberVideoGridUI {...props} />;
  if (!tabs || tabs.length === 0) return;

  const bodies = tabs
    .filter((el) => el.show)
    .map((tab, index) => {
      return (
        <div className={`${tab.type !== selected ? "hidden" : ""}`} key={index}>
          {tab.type === "participants" ? memberVideoGridUI : null}
          {tab.type === "chat" ? chatUI : null}
          {tab.type === "summary" ? (
            <SummaryUI
              {...props}
              chatRef={chatRef}
              paginationRef={paginationRef}
            />
          ) : null}
        </div>
      );
    });
  return (
    <React.Fragment>
      <div className={"Body"}>{bodies}</div>
    </React.Fragment>
  );
};

const ChatUI = (props) => {
  const {
    chatRef,
    workoutData,
    gymData,
    staffsInActivity,
    coachData,
    allUsers,
    userActivityData,
    chatSelected,
    socket,
  } = props;
  console.log("chat_ui");
  return (
    <Chat
      ref={chatRef}
      workoutData={workoutData}
      gymName={gymData.name}
      staffsInActivity={staffsInActivity}
      coachData={coachData}
      memberData={allUsers[userActivityData.user_id]}
      userActivityData={userActivityData}
      userId={userActivityData.user_id}
      userSessionId={userActivityData.user_activity_session_id}
      chatUxToggle={chatSelected}
      socket={socket}
    />
  );
};

const SummaryUI = (props) => {
  const { allUsers } = props;
  return <Summary allUsers={allUsers} />;
};
const MemberVideoGridUI = (props) => {
  const { allUsers, userPin, zoom, isHangoutRoom } = props;
  return (
    <MembersVideoGrid
      allUsers={allUsers}
      userPin={userPin}
      zoom={zoom}
      isHangout={isHangoutRoom}
    />
  );
};
